import { useEffect, useState } from "react";
import { C_colorAccent, C_colorPrimaryDark, C_uniformeBlanco, C_uniformeGrisOscuro, C_uniformeNegro, ID_MODULO_ADMIN_CANCHAS, ID_MODULO_ADMIN_CONFIGURACION, ID_MODULO_ADMIN_TORNEO, ID_MODULO_PRINCIPAL_ADMIN, SEPARADOR_PARAMETROS_BD } from "../constantes/generales";
import ShowError from "../recVisual/ShowError";
import Loader from "../recVisual/Loader";
import { crearTabla, guardarDatoLocal, infoGuardadaEsMismoDia, presentarError, presentarLog, quitarTildes, recuperarDatoLocal, reportarError, valorNumero } from "../helpers/funciones";

import ic_salir from '../recGraficos/ic_salir_w.png'
import ic_jugadorsinimagen from '../recGraficos/ic_jugadorsinimagen.png';
import ic_flecha_expandir from '../recGraficos/ic_flecha_expandir.png';
import ic_configura_blanco from '../recGraficos/ic_configura_blanco.png';
import ic_torneo from '../recGraficos/ic_torneo.png';
import ic_escudo_base2_w from '../recGraficos/ic_escudo_base2_w.png';
import ic_silbato from '../recGraficos/ic_silbato.png';
import ic_partido_verde from '../recGraficos/ic_partido_verde.png';
import ic_rayo_accent from '../recGraficos/ic_rayo_accent.png';
import ic_nuevo_primary from '../recGraficos/ic_nuevo_primary.png';
import ic_buscar_gris from '../recGraficos/ic_buscar_gris.png';
import ic_transparente from '../recGraficos/ic_transparente.png';
import DinamicoListaMensajes from "../gestionVisual/DinamicoListaMensajes";
import { getDatos } from "../gestionDatos/getDatos";
import DinamicoElementosTorneo from "../gestionVisual/DinamicoElementosTorneo";


let ruta=recuperarDatoLocal("rutaRecursos");
const nomClase="Admin_Configuracion_WB";
const idModulo=ID_MODULO_ADMIN_CONFIGURACION;

let idUser="";
let tipoUser=recuperarDatoLocal("tipoUser");
let idSede=recuperarDatoLocal("idSede");


let titulo="";
let mensaje="";
let ventanaMensaje;

let datosInicial = {
    tituloVentana:"",
    fotoUsuario:ic_jugadorsinimagen,
    rolUsuario:"",
    nomUsuario:"",
    nomEmpresa:"",
    nomSede:""
};

let tipoLista="ACTIVOS";

let cancelarBusqueda=false;
let textoBuscar="";
let tipoSeleccion="TORNEOS";


let torneosSedeO = [];
let torneosSede = [];
let torneo = {
            indice: 0,
            idTorneo:"",
            escudo:"",
            nombre:"",            
            sinInfo1:"",
            activo:"",
            sinInfo2:"",
            nomBusqueda:""
    }
function crearInfoTorneosSede(datos){    
    const nomFuncion="crearInfoTorneosSede";

    try{        
        
    
        torneosSedeO = [];
        torneosSede = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , torneo);
            registro.indice=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idTorneo=datos[i][j];
                if(j===1) registro.escudo=datos[i][j];
                if(j===2){
                    registro.nombre=datos[i][j];
                    registro.nomBusqueda=quitarTildes(datos[i][j]).toUpperCase();
                }                
                if(j===3) registro.sinInfo1=datos[i][j];
                if(j===4) registro.activo=datos[i][j];
                if(j===5) registro.sinInfo2=datos[i][j];
            }

            torneosSedeO.push(registro);
            torneosSede.push(datos[i]);

        }


    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

let canchasSedeO = [];
let canchasSede = [];
let cancha = {
            indice: 0,
            idCancha:"",
            sinInfo1:"",
            nombreNum:"",
            nombre:"",
            activo:"",
            horario:"",
            numero:"",
            nomBusqueda:"",
            borrado:"0"
    }
function crearInfoCanchasSede(datos){    
    const nomFuncion="crearInfoCanchasSede";

    try{        
        
    
        canchasSedeO = [];
        canchasSede = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , cancha);
            registro.indice=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idCancha=datos[i][j];
                if(j===1) registro.sinInfo1=datos[i][j];
                if(j===2) registro.nombreNum=datos[i][j];
                if(j===3){
                    registro.nombre=datos[i][j];
                    registro.nomBusqueda=quitarTildes(datos[i][j]).toUpperCase();
                }                
                if(j===4) registro.activo=datos[i][j];
                if(j===5) registro.horario=datos[i][j];
                if(j===6) registro.numero=datos[i][j];
            }

            canchasSedeO.push(registro);
            canchasSede.push(datos[i]);

        }


    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

let jugadoresSedeO = [];
let jugadoresSede = [];
function crearInfoJugadoresSede(datos){    
    const nomFuncion="crearInfoJugadoresSede";

    try{        
        let jugador = {
            idjugador:"",
            foto:"",
            nombre:"",
            telefono:"",
            registrado:"",
            pendiente:"",
            cantEquipos:"",
            nomBusqueda:"",
        }
    
        jugadoresSedeO = [];
        jugadoresSede = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , jugador);
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idjugador=datos[i][j];
                if(j===1) registro.foto=datos[i][j];
                if(j===2){
                    registro.nombre=datos[i][j];
                    registro.nomBusqueda=quitarTildes(datos[i][j]).toUpperCase();
                }
                if(j===3) registro.telefono=datos[i][j];
                if(j===4) registro.registrado=datos[i][j];
                if(j===5) registro.pendiente=datos[i][j];
                if(j===6) registro.cantEquipos=datos[i][j];
            }
            jugadoresSedeO.push(registro);
            jugadoresSede.push(datos[i]);

        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

let equiposSedeO = [];
let equiposSede = [];
function crearInfoEquiposSede(datos){    
    const nomFuncion="crearInfoEquiposSede";

    try{        
        let equipo = {
            indice: 0,
            idEquipo:"",
            escudo:"",
            nombreLargo:"",
            sinInfo:"",
            activo:"",
            tJugadores:"",
            jEnTorneo:"",
            nomTorneo:"",
            nomLargoBusqueda:"",
            nomTorneoBusqueda:"",
            jugadores:[],
            maxJugTorneo:0,
            jugSeleccionados:0
        }
    
        equiposSedeO = [];
        equiposSede = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , equipo);
            registro.indice=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idEquipo=datos[i][j];
                if(j===1) registro.escudo=datos[i][j];
                if(j===2){
                    registro.nombreLargo=datos[i][j];
                    registro.nomLargoBusqueda=quitarTildes(datos[i][j]).toUpperCase();
                }
                if(j===3) registro.sinInfo=datos[i][j];
                if(j===4) registro.activo=datos[i][j];
                if(j===5) registro.tJugadores=datos[i][j];
                if(j===6) registro.jEnTorneo=datos[i][j];
                if(j===7){
                    registro.nomTorneo=datos[i][j];
                    registro.nomTorneoBusqueda=quitarTildes(datos[i][j]).toUpperCase();
                }
            }

            //having tjugadores>0 and (tjugadores-jentorneo)>0
            if(valorNumero(registro.tJugadores)>0){
                equiposSedeO.push(registro);
                equiposSede.push(datos[i]);
            }            

        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}


const Admin_Configuracion = ({params="", definirModulo, modOrigen=0, paramOrigen=""}) => {
    const [esError, setEsError] = useState(0);
    const [loading, setLoading] = useState(false);
    const [showMensaje, setShowMensaje] = useState(false);
    const [msjModal, setMsjModal] = useState("");


    const [datosMod, setDatosMod] = useState(datosInicial);
    const [seccionSelUS, setSeccionSelUS] = useState("");

    const [imagenSeccionUS, setImagenSeccionUS] = useState(ic_torneo);
    const [tituloSeccionUS, setTituloSeccionUS] = useState("Torneos");

    const [filtroUS, setFiltroUS] = useState("");
    const [tipoListaUS, setTipoListaUS] = useState("ACTIVOS");

    const [datosEncontrados, setDatosEncontrados] = useState([]);
    const [datosCargadosBusqueda, setDatosCargadosBusqueda] = useState(false);


    var respuesta = {
            datos: "",
            exito: false,
            conectado: false,
            hayDatos: false,
            mensaje: ''
        }
    
        useEffect(() => {
            const nomFuncion="useEffect";
    
            try{       
                idSede=recuperarDatoLocal("idSede");
                generarDatosPresentar();

                if(params==="CANCHAS"){
                    clickGenerico("CLICK_SECCION",params);
                }
        
    
            }catch(err){
                reportarError( nomClase, nomFuncion, "", err);
            }     
            
    
        }, [params]);


    const BD_solicitarDatos = (tipoDatos, params) => {
            let nomFuncion="BD_solicitarDatos"; 
    
            try{
                let actualizar=true;
                let SEP=SEPARADOR_PARAMETROS_BD;
                let paramQuery="";
                let tipoConsulta="";
                let funcion="";
                let consulta="";
                let zonaHoraria="0";
                let mostrarError=true;
                let mostrarProcesando=true;
    
                let codigoFinal="";
                
                if(actualizar){      
                    
                    zonaHoraria="" + valorNumero(recuperarDatoLocal("zonahoraria"));
    
                    if(tipoDatos==="INFO_CANCHAS_SEDE"){
                        tipoConsulta="consultarTabla";
                        funcion="getInfoSede";
                        consulta="INFO_CANCHAS_SEDE";
                        mostrarProcesando=false;
                        
                        paramQuery= idSede;
    
                    } else if(tipoDatos==="INFO_TORNEOS_SEDE"){
                        tipoConsulta="consultarTabla";
                        funcion="getInfoSede";
                        consulta="INFO_TORNEOS_SEDE";
                        mostrarProcesando=false;
                        
                        paramQuery= idSede;
    
                    } 
                    
                    if(mostrarProcesando) setLoading(true);
    
                    getDatos()
                    .get(tipoConsulta,funcion,consulta,paramQuery,zonaHoraria)
                    .then((res) => {
                        nomFuncion="BD_solicitarDatos.respuesta"; 
    
                        try{
                            respuesta=res;
                            if (respuesta.exito) {
                                if(tipoDatos==="INFO_CANCHAS_SEDE"){
                                    presentarLog(nomClase + " - SOLICITA_DATOS CANCHAS_SEDE"); 
    
                                    guardarDatoLocal("ultAccesoICS" + idSede,Date.now());
                                    guardarDatoLocal("datosICS" + idSede, respuesta.datos);
            
                                    crearInfoCanchasSede(crearTabla(respuesta.datos,"1")); 

                                    guardarDatoLocal("infoCanchasSede",JSON.stringify(canchasSedeO));
                                    setDatosCargadosBusqueda(true);
    
                                    buscarTexto();
                                } else if(tipoDatos==="INFO_TORNEOS_SEDE"){
                                    presentarLog(nomClase + " - SOLICITA_DATOS TORNEOS_SEDE"); 
    
                                    guardarDatoLocal("ultAcceso" + idModulo + "ITS" + idSede,Date.now());
                                    guardarDatoLocal("datos" + idModulo + "ITS" + idSede, respuesta.datos);
            
                                    crearInfoTorneosSede(crearTabla(respuesta.datos,"1")); 
                                    setDatosCargadosBusqueda(true);
    
                                    buscarTexto();
                                } 
                
                            } else {
                                if(respuesta.conectado){
                                    reportarError( nomClase, nomFuncion, respuesta.mensaje, "");
                                    if(mostrarError) setEsError(1);
                                } 
                                else{    
                                    presentarError(nomClase,nomFuncion,respuesta.mensaje,"");                        
                                    setEsError(2);
                                }                       
                            }
    
                        }catch(err){
                            reportarError( nomClase, nomFuncion, "", err);
                        } 
                        
            
                        setLoading(false);
                        
                    });
                }
                
               
    
            }catch(err){
                reportarError( nomClase, nomFuncion, "", err);
            }  
        } 

    const generarDatosPresentar = () => {
        let nomFuncion="generarDatosPresentar";

        try{
  
            let datosTemp=JSON.parse(JSON.stringify(datosMod));         

            datosTemp.nomUsuario=recuperarDatoLocal("nomUsuario");
            datosTemp.nomEmpresa=recuperarDatoLocal("nomEmpresa");
            datosTemp.nomSede=recuperarDatoLocal("nomSede");
            datosTemp.fotoUsuario=recuperarDatoLocal("fotoUsuario");
            if(datosTemp.fotoUsuario!=="") datosTemp.fotoUsuario= ruta + datosTemp.fotoUsuario;
            else datosTemp.fotoUsuario=ic_jugadorsinimagen;

            datosTemp.tituloVentana="Configuración";
            datosTemp.rolUsuario="Administrador:";  

            setDatosMod(datosTemp);


        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        } 

    }

    const cargarDatosGuardadosTorneosSede = () => {
            let nomFuncion="cargarDatosGuardadosTorneosSede"; 
    
            try{             
                presentarLog(nomClase + " - RECUPERA_DATOS TORNEOS_SEDE"); 
                let datosModulo=recuperarDatoLocal("datos" + idModulo + "ITS" + idSede);
    
                if(datosModulo!==""){
                    crearInfoTorneosSede(crearTabla(datosModulo,"1"));   
                    setDatosCargadosBusqueda(true);  
    
                    buscarTexto();
                } 
                else BD_solicitarDatos("INFO_TORNEOS_SEDE"); 
    
            }catch(err){
                reportarError( nomClase, nomFuncion, "", err);
            } 
        }

    const cargarDatosGuardadosCanchasSede = () => {
            let nomFuncion="cargarDatosGuardadosCanchasSede"; 
    
            try{             
                presentarLog(nomClase + " - RECUPERA_DATOS CANCHAS_SEDE"); 
                let datosModulo=recuperarDatoLocal("datosICS" + idSede);
    
                if(datosModulo!==""){
                    crearInfoCanchasSede(crearTabla(datosModulo,"1"));   

                    guardarDatoLocal("infoCanchasSede",JSON.stringify(canchasSedeO));
                    setDatosCargadosBusqueda(true);  
    
                    buscarTexto();
                } 
                else BD_solicitarDatos("INFO_CANCHAS_SEDE"); 
    
            }catch(err){
                reportarError( nomClase, nomFuncion, "", err);
            } 
        }



    const buscarTexto = () => {
            let nomFuncion="buscarTexto";
    
            try{
                cancelarBusqueda=false;
                let regPagina=20;
                let mostrarJugadoresSede=false;
                let tempDatosEncontrados=[];
                let llavesIncluidas=[];
    
    
                if(tipoUser==="administrador") mostrarJugadoresSede=true;
                
    
                if(true){
                    
                    let datos=[];
                    let datosTI=false;
    
                    if(tipoSeleccion==="Telefono_Delegado" || tipoSeleccion==="Nombre_Delegado"){
                        if(textoBuscar!=="" && jugadoresSedeO.length>0 && mostrarJugadoresSede){
                            datos=JSON.parse(JSON.stringify(jugadoresSedeO));
                        } 
                    }
                    else if(tipoSeleccion==="Torneos_Sede"){
                        datos=JSON.parse(JSON.stringify(torneosSedeO));
                    }
                    else if(tipoSeleccion==="Equipo_Sede"){
                        datos=JSON.parse(JSON.stringify(equiposSedeO));
                    }
                    else if(tipoSeleccion==="Cancha_Sede"){
                        datos=JSON.parse(JSON.stringify(canchasSedeO));    
                    }
    
    
                    if(datos.length>0) datosTI=true;
    
    
                    let total=0;
                    let texto="", textoBuscado="";
                    
                    textoBuscado=textoBuscar;
                    textoBuscado=textoBuscado.replaceAll("+","");
                    textoBuscado=quitarTildes(textoBuscado).toUpperCase();
    
                    if(datosTI){
                            let i;
                            cancelarBusqueda=false;

                            let activo="";
                            if(tipoLista==="ACTIVOS") activo="1";
                            if(tipoLista==="INACTIVOS") activo="0";
    
                            for(i=0;i<datos.length;i++){
                                if(cancelarBusqueda) return;
    
                                if(!cancelarBusqueda){
                                    let incluir=false;                                
    
                                    if(tipoSeleccion==="Torneos_Sede"){
                                        texto=datos[i].nomBusqueda;
                                        if((activo==="" || datos[i].activo===activo) && (textoBuscado==="" || texto.includes(textoBuscado))) incluir=true;
                                    }
                                    else if(tipoSeleccion==="Equipo_Sede"){
                                        texto=datos[i].nomLargoBusqueda;
                                        if(textoBuscado==="" || texto.includes(textoBuscado)) incluir=true;
                                        else{
                                            texto=datos[i].nomTorneoBusqueda;
                                            if(texto.includes(textoBuscado)) incluir=true;
                                        }
                                    } else if(tipoSeleccion==="Cancha_Sede"){
                                        texto=datos[i].nomBusqueda;
                                        if((activo==="" || datos[i].activo===activo) && (textoBuscado==="" || texto.includes(textoBuscado))) incluir=true;
                                    }
    
    
                                    if(incluir){                                    
                                       
                                        let llave="";
                                        let dato2="";
                                        if(tipoSeleccion==="Telefono_Delegado" || tipoSeleccion==="Nombre_Delegado"){
                                            llave=datos[i].telefono;                            
                                        } else if(tipoSeleccion==="Torneos_Sede"){
                                            llave=datos[i].idTorneo;
                                            dato2=datos[i].nombre;
                                        } else if(tipoSeleccion==="Equipo_Sede"){
                                            llave=datos[i].idEquipo;
                                            dato2=datos[i].nombreLargo;
                                        } else if(tipoSeleccion==="Cancha_Sede"){
                                            llave=datos[i].idCancha;
                                        }
    
                                        let correcto=true;
                                        for(let j=0;j<llavesIncluidas.length;j++){
                                                if(llavesIncluidas[j]===llave){
                                                    correcto=false;
                                                    j=llavesIncluidas.length;
                                                }
                                        }
    
                                        if(correcto && !tipoSeleccion.includes("Delegado")){
                                            //correcto=!yaEstaInscrito(tipoSeleccion,llave,dato2);
                                        }
                                            
                                        if(correcto){
                                                tempDatosEncontrados.push(datos[i]);
                                                llavesIncluidas.push(llave);
                                                total++;
                                        }
                                        
    
                                        if(total>=regPagina) i=datos.length;
                                    }
    
                                }
                                else i=datos.length;
    
                            }
    
                    }
    
                    if(total==0) {
                        if (tipoSeleccion==="Telefono_Delegado") {
                            if (textoBuscado.length >=10 && textoBuscado.length < 15){
                                total++;
                                let tempJugador = {
                                    idjugador:"",
                                    foto:"",
                                    nombre:"Delegado Nuevo",
                                    telefono: textoBuscado,
                                    registrado:"1",
                                    pendiente:"3",
                                    cantEquipos:""
                                }
                                
                                tempDatosEncontrados.push(tempJugador);
                            }
                            
                        }
    
                    }
    
    
                    if(!cancelarBusqueda) setDatosEncontrados(tempDatosEncontrados);  
    
                }
                else setDatosEncontrados(tempDatosEncontrados);
    
    
    
            }catch(err){
                reportarError( nomClase, nomFuncion, "", err);
            } 
    
        }

    
    const validarCampo = (e, campo, maxlen) => {
            let nomFuncion="validarCampo"; 
    
            try{
                let newValor = e.target.value;
                if(!campo.includes("PARAMETRO_") && maxlen!==null && newValor.length>maxlen) newValor=newValor.substring(0,maxlen);
    
                //let tempArreglo=JSON.parse(JSON.stringify(arrCampos));
    
                if(campo==="FILTRO_BUSQUEDA"){                           
                    setFiltroUS(newValor);  
                    textoBuscar=newValor;
                    
                    cancelarBusqueda=true;
                    buscarTexto();          
    
                }       
                
    
            }catch(err){
                reportarError( nomClase, nomFuncion, "", err);
            }         
            
        }

    const clickGenerico = (donde, params=null) => {
        let nomFuncion="clickGenerico"; 

        try{
            
            let tempArreglo=null;
            let parametros="";
            
            switch(donde) {
                case "CLICK_SECCION":
                    setSeccionSelUS(params);
                    setFiltroUS("");
                    setTipoListaUS("ACTIVOS");
                    tipoLista="ACTIVOS";
                    textoBuscar="";
                    
                    if(params==="TORNEOS"){
                        setImagenSeccionUS(ic_torneo);
                        setTituloSeccionUS("Torneos");

                        tipoSeleccion="Torneos_Sede";

                        let infoTorneos=infoGuardadaEsMismoDia(idModulo,"ITS" + idSede);                    
                        if(!infoTorneos) BD_solicitarDatos("INFO_TORNEOS_SEDE"); 
                        else cargarDatosGuardadosTorneosSede();  

                        cancelarBusqueda=false;
                        setDatosEncontrados([]);      

                        buscarTexto();
                    }  
                    else if(params==="EQUIPOS"){
                        setImagenSeccionUS(ic_escudo_base2_w);
                        setTituloSeccionUS("Equipos");
                    } 
                    else if(params==="JUGADORES"){
                        setImagenSeccionUS(ic_jugadorsinimagen);
                        setTituloSeccionUS("Jugadores");
                    } 
                    else if(params==="ARBITROS"){
                        setImagenSeccionUS(ic_silbato);
                        setTituloSeccionUS("Árbitros");
                    } 
                    else if(params==="CANCHAS"){
                        setImagenSeccionUS(ic_partido_verde);
                        setTituloSeccionUS("Canchas");

                        tipoSeleccion="Cancha_Sede";

                        let infoCanchas=infoGuardadaEsMismoDia("ICS" + idSede);                    
                        if(!infoCanchas) BD_solicitarDatos("INFO_CANCHAS_SEDE"); 
                        else cargarDatosGuardadosCanchasSede();  

                        cancelarBusqueda=false;
                        setDatosEncontrados([]);  

                        buscarTexto();
                    } 
                    else if(params==="CARGA_MASIVA"){
                        setImagenSeccionUS(ic_rayo_accent);
                        setTituloSeccionUS("Carga Masiva");
                    }                 
                     
                    break;  
                case "CLICK_SELECCIONAR_TORNEO":
                    parametros=torneosSedeO[params].idTorneo;
                    definirModulo(0, idModulo, "", ID_MODULO_ADMIN_TORNEO, parametros); 

                    break;                
                case "CLICK_SELECCIONAR_CANCHA":
                    parametros=canchasSedeO[params].idCancha;
                    definirModulo(0, idModulo, "", ID_MODULO_ADMIN_CANCHAS, parametros); 

                    break;
                case "CLICK_NUEVO":

                    if(tipoSeleccion==="Torneos_Sede") definirModulo(0, idModulo, "", ID_MODULO_ADMIN_TORNEO, "-1"); 
                    if(tipoSeleccion==="Cancha_Sede") definirModulo(0, idModulo, "", ID_MODULO_ADMIN_CANCHAS, "-1"); 

                    break;
                default:
                    break;
            }

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  
    } 


    const salir = () => {        
        let idUser=recuperarDatoLocal("idUser");
        definirModulo(0,idModulo,params,ID_MODULO_PRINCIPAL_ADMIN,idUser);   
    }

    return (
        <>

            {showMensaje && (ventanaMensaje)}

            {/* BARRA TITULO VENTANA */}
            <div className="CT_zonaFija">
                <div className="CT_encabezado">
                    <div className="CT_elementoEncabezado" onClick={salir}><img src={ic_salir} className="IM_imgIcono24" alt="" style={{padding: "8px", cursor:"pointer"}} />  </div>
                    <div className="CT_elementoEncabezado"><img className="IM_imgRedondeada36" height="36px" width="36px" src={ic_configura_blanco} alt="" /></div>
                    <div className="CT_elementoEncabezado"><p className="TX_unaSolaLinea">{datosMod.tituloVentana}</p></div>
                </div>
            </div>

            {/* ZONA INFO USUARIO, EMPRESA Y SEDE */}
            <div style={{paddingTop:"50px"}}>
                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", background:C_colorPrimaryDark, color:C_uniformeBlanco}}>
                    <img className="IM_imgRedondeada46" src={datosMod.fotoUsuario} alt="" style={{padding:"8px"}}/>
                    <div style={{flex:"1", fontSize:"14px", textAlign:"left", color: C_colorAccent }}>
                        <div className="TX_unaSolaLinea2"><span style={{marginRight:"10px"}}>{datosMod.rolUsuario}</span><span style={{color:C_uniformeBlanco}}>{datosMod.nomUsuario}</span></div>
                        <div className="TX_unaSolaLinea2"><span style={{marginRight:"10px"}}>{"Empresa:"}</span><span style={{color:C_uniformeBlanco}}>{datosMod.nomEmpresa}</span></div>
                        <div className="TX_unaSolaLinea2"><span style={{marginRight:"10px"}}>{"Sede:"}</span><span style={{color:C_uniformeBlanco}}>{datosMod.nomSede}</span></div>
                    </div> 
                </div>     
            </div>
            
                          

            {!loading && esError===0 && (
                <div style={{margin: "10px", paddingBottom:"20px"}}>  
                                       

                    {/* MENU INICIAL */}
                   {seccionSelUS==="" && (
                        <div style={{display:"flex", flexWrap:"wrap", justifyContent:"center", alignItems:"center", gap:"30px", textAlign:"left", maxWidth:"800px", marginTop:"30px"}}>
                            <div style={{flexShrink:"1", flexGrow:"1", minWidth:"200px", maxWidth:"350px", cursor:"pointer"}} onClick={() => {clickGenerico("CLICK_SECCION","TORNEOS")}}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                                    <img className="IM_imgIcono46" src={ic_torneo} alt="" style={{padding:"10px"}}/>
                                    <div style={{marginLeft:"10px"}}>
                                        <div style={{fontSize:"20px", fontWeight:"bold", color:C_uniformeNegro}}>Torneos</div>
                                        <div style={{fontSize:"16px",  color:C_uniformeGrisOscuro}}>Crea, edita y administra tus torneos.</div>
                                    </div>
                                </div>
                            </div>

                            <div style={{flexShrink:"1", flexGrow:"1", minWidth:"200px", maxWidth:"350px", cursor:"pointer"}} onClick={() => {clickGenerico("CLICK_SECCION","EQUIPOS")}}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                                    <img className="IM_imgIcono46" src={ic_escudo_base2_w} alt="" style={{padding:"10px"}}/>
                                    <div style={{marginLeft:"10px"}}>
                                        <div style={{fontSize:"20px", fontWeight:"bold", color:C_uniformeNegro}}>Equipos</div>
                                        <div style={{fontSize:"16px",  color:C_uniformeGrisOscuro}}>Consulta y edita la información de los equipos de tu sede.</div>
                                    </div>
                                </div>
                            </div>

                            <div style={{flexShrink:"1", flexGrow:"1", minWidth:"200px", maxWidth:"350px", cursor:"pointer"}} onClick={() => {clickGenerico("CLICK_SECCION","JUGADORES")}}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                                    <img className="IM_imgIcono46" src={ic_jugadorsinimagen} alt="" style={{padding:"10px"}}/>
                                    <div style={{marginLeft:"10px"}}>
                                        <div style={{fontSize:"20px", fontWeight:"bold", color:C_uniformeNegro}}>Jugadores</div>
                                        <div style={{fontSize:"16px",  color:C_uniformeGrisOscuro}}>Consulta la información de los jugadores de tus torneos.</div>
                                    </div>
                                </div>
                            </div>                      

                            <div style={{flexShrink:"1", flexGrow:"1", minWidth:"200px", maxWidth:"350px", cursor:"pointer"}} onClick={() => {clickGenerico("CLICK_SECCION","ARBITROS")}}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                                    <img className="IM_imgIcono46" src={ic_silbato} alt="" style={{padding:"10px"}}/>
                                    <div style={{marginLeft:"10px"}}>
                                        <div style={{fontSize:"20px", fontWeight:"bold", color:C_uniformeNegro}}>Árbitros</div>
                                        <div style={{fontSize:"16px",  color:C_uniformeGrisOscuro}}>Registra, edita y administra los árbitros de tus torneos.</div>
                                    </div>
                                </div>
                            </div>

                            <div style={{flexShrink:"1", flexGrow:"1", minWidth:"200px", maxWidth:"350px", cursor:"pointer"}} onClick={() => {clickGenerico("CLICK_SECCION","CANCHAS")}}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                                    <img className="IM_imgIcono46" src={ic_partido_verde} alt="" style={{padding:"10px"}}/>
                                    <div style={{marginLeft:"10px"}}>
                                        <div style={{fontSize:"20px", fontWeight:"bold", color:C_uniformeNegro}}>Canchas</div>
                                        <div style={{fontSize:"16px",  color:C_uniformeGrisOscuro}}>Administra las canchas de tu sede.</div>
                                    </div>
                                </div>
                            </div>

                            <div style={{flexShrink:"1", flexGrow:"1", minWidth:"200px", maxWidth:"350px", cursor:"pointer"}} onClick={() => {clickGenerico("CLICK_SECCION","CARGA_MASIVA")}}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                                    <img className="IM_imgIcono46" src={ic_rayo_accent} alt="" style={{padding:"10px"}}/>
                                    <div style={{marginLeft:"10px"}}>
                                        <div style={{fontSize:"20px", fontWeight:"bold", color:C_uniformeNegro}}>Carga Masiva</div>
                                        <div style={{fontSize:"16px",  color:C_uniformeGrisOscuro}}>Carga facilmente la información de tus torneos, equipos y jugadores</div>
                                    </div>
                                </div>
                            </div>
                    </div>
                   )}

                    {/* SUB MENU */}
                    {seccionSelUS!=="" && (<>
                        <div className="CT_contenedorTitulo" style={{marginBottom:"20px"}}>
                            <img className='IM_imgIcono28' src={ic_flecha_expandir} alt='' style={{padding:"10px", cursor:"pointer"}} onClick={() => {setSeccionSelUS("")}}/>   
                            <img className='IM_imgRedondeada36' src={imagenSeccionUS} alt='' style={{marginInline:"10px"}}/>   
                            <div style={{flex:"1", fontSize:"18px", fontWeight:"bold", textAlign:"left"}}>{tituloSeccionUS}</div>     
                            {(seccionSelUS==="TORNEOS" || seccionSelUS==="ARBITROS" || seccionSelUS==="CANCHAS") && (<img className='IM_imgIcono28' src={ic_nuevo_primary} alt='' style={{padding:"10px", cursor:"pointer"}} onClick={() => {clickGenerico("CLICK_NUEVO")}}/> )}
                        </div>

                        {seccionSelUS!=="CARGA_MASIVA" && (                            
                        <div style={{maxWidth:"500px"}}>
                            
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingInline:"6px"}}>
                                    <input type="text" className='IP_entradas' value={filtroUS} style={{flexGrow: 1, flexShrink: 1, flexBasis: "150px"}} placeholder="Buscar"  onChange={(e) => {validarCampo(e,"FILTRO_BUSQUEDA",40)}} />
                                    <img className='IM_imgIcono28' src={ic_buscar_gris} alt='' />  
                                </div>     

                                <div style={{ display: "flex", justifyContent: "space-around", alignItems:"center"}}>
                                                <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center", cursor:"pointer"}}  onClick={() => {setTipoListaUS("ACTIVOS"); tipoLista="ACTIVOS"; buscarTexto()}}>
                                                    <input type="radio" value="ACTIVOS" name="tipoLista" style={{marginBlock: "0px", marginRight:"20px"}} checked={tipoListaUS==="ACTIVOS" ? true : false} onChange={() => {setTipoListaUS("ACTIVOS"); tipoLista="ACTIVOS"; buscarTexto()}}/>
                                                    <div>Activos</div>
                                                </div>
                                                <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center", cursor:"pointer"}}  onClick={() => {setTipoListaUS("INACTIVOS"); tipoLista="INACTIVOS"; buscarTexto()}}>
                                                    <input type="radio" value="INACTIVOS" name="tipoLista" style={{marginBlock: "15px", marginRight:"20px"}} checked={tipoListaUS==="INACTIVOS" ? true : false} onChange={() => {setTipoListaUS("INACTIVOS"); tipoLista="INACTIVOS"; buscarTexto()}}/>
                                                    <div>Inactivos</div>
                                                </div>
                                                <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center", cursor:"pointer"}}  onClick={() => {setTipoListaUS("TODOS"); tipoLista="TODOS"; buscarTexto()}}>
                                                    <input type="radio" value="TODOS" name="tipoLista" style={{marginBlock: "0px", marginRight:"20px"}} checked={tipoListaUS==="TODOS" ? true : false} onChange={() => {setTipoListaUS("TODOS"); tipoLista="TODOS"; buscarTexto()}}/>
                                                    <div>Todos</div>
                                                </div>
                                                <img className='IM_imgIcono28' src={ic_transparente} alt='' />  
                                </div>    

                                <div style={{flex:"1", overflowY:"auto",  maxHeight:"100%", maxWidth:"100%"}}>
                                    
                                    {seccionSelUS==="TORNEOS" && datosEncontrados.length>0 && (<> 
                                        {(datosEncontrados.map((reg, index) => (<DinamicoElementosTorneo key={index} registro={index} numRegistro={index+1} tipoLista={"CONFIGURACION_ADMIN_TORNEOS"} datos={reg} definirModulo={clickGenerico} incluirLinea={true} />))  )}      
                                    </>)} 

                                    {seccionSelUS==="CANCHAS" && datosEncontrados.length>0 && (<> 
                                        {(datosEncontrados.map((reg, index) => (<DinamicoElementosTorneo key={index} registro={index} numRegistro={index+1} tipoLista={"CONFIGURACION_ADMIN_CANCHAS"} datos={reg} definirModulo={clickGenerico} incluirLinea={true} />))  )}      
                                    </>)}   
                                    
                                    {datosEncontrados.length===0 && (<div className="TX_sinInfo">No existen resultados que coincidan con la busqueda realizada</div>)}                                 

                                </div>                                

                        </div> 
                        )}                       
                        

                    </>)}                 


                </div>
            )}
                
           

            {esError!==0 && <ShowError tipoError={esError} funcionCerrar={salir} />}

            {loading && <Loader tipo={"TOTAL"}/>}   
        </>
    );

};

export default Admin_Configuracion;